import $ from "jquery";
import { debounce, pxToRem } from "../utils/functions";

const $window = $(window);

const table = (tableEl, index) => {
  let $table = tableEl.find(".table");

  if ($table.length === 0) {
    tableEl.find("table").wrap('<div class="table"></div>');
    $table = tableEl.find(".table");
  }

  $window.off(`resize:width.wpBlockTableFixed${index}`);
  if (tableEl.find(".has-fixed-layout").length) {
    normalizeTable(tableEl);
    $window.on(
      `resize:width.wpBlockTableFixed${index}`,
      debounce(() => normalizeTable(tableEl))
    );
  }

  tableOverflow($table);
  $table.off("scroll");
  $table.on("scroll", function () {
    tableOverflow($table);
  });
  $window.off(`resize:width.wpBlockTable${index}`);
  $window.on(
    `resize:width.wpBlockTable${index}`,
    debounce(() => tableOverflow($table))
  );
};

const normalizeTable = (tableEl) => {
  const cells = tableEl.find("th, td");
  cells.css({
    "min-width": "",
    "max-width": "",
  });
  let firstHeadRow = tableEl.find("thead tr");
  if (firstHeadRow.length) {
    const width = firstHeadRow.outerWidth();
    firstHeadRow = firstHeadRow.slice(0, 1).find("th");

    const numOfCols = firstHeadRow.length;
    if (numOfCols) {
      let colWidth = 0;
      firstHeadRow.each(function () {
        colWidth += $(this).outerWidth();
      });
      if (colWidth < width) {
        colWidth = width;
      }
      colWidth = colWidth / numOfCols;
      cells.css({
        "min-width": pxToRem(colWidth),
        "max-width": pxToRem(colWidth),
      });
    }
  }
};

const tableScrolledLeft = (tableEl) => tableEl.scrollLeft() === 0;
const tableScrolledRight = (tableEl) =>
  Math.ceil(tableEl.scrollLeft() + tableEl.outerWidth()) >=
  Math.ceil(tableEl[0].scrollWidth);

function tableOverflow(tableEl) {
  const $parent = tableEl.closest(".wp-block-table");

  if (tableScrolledLeft(tableEl) && tableScrolledRight(tableEl)) {
    $parent.addClass("table-is-left table-is-right");
  } else {
    if (tableScrolledLeft(tableEl)) {
      $parent.addClass("table-is-left");
    } else {
      $parent.removeClass("table-is-left");
    }

    if (tableScrolledRight(tableEl)) {
      $parent.addClass("table-is-right");
    } else {
      $parent.removeClass("table-is-right");
    }
  }
}

export const reloadScriptWpBlockTable = () => {
  const $tableEl = $(".wp-block-table");

  if ($tableEl.length > 0) {
    $tableEl.each(function (index) {
      table($(this), index);
    });
  }
};
reloadScriptWpBlockTable();
